import React from 'react'

import { BookEnum } from '@interfaces/BookEnum'
import { useGetNewBooks } from '@hooks/newest/useGetNewBooks'
import { useAuthentication } from '@hooks/useAuthentication'
import { NewestPageProps, WithNewestPageProps } from './interface'

export function withNewestPage(Component: React.FC<NewestPageProps>) {
  function WithNewestPage({ bookType }: WithNewestPageProps) {
    const { isUserLoading } = useAuthentication()
    const { data, isLoading, handleFetchNextPage } = useGetNewBooks({
      limitPerPage: 20,
      bookType: bookType ? [bookType] : [BookEnum.NOVEL, BookEnum.MANGA],
    })

    const newProps = {
      data,
      bookType,
      isLoading: isLoading || isUserLoading,
      handleFetchNextPage,
    }

    return <Component {...newProps} />
  }
  return WithNewestPage
}
